export enum MenuApiMethods {
    getMenu = "Menus.GetPublicMenu",
    menusReportCallWaiter = "Menus.ReportCallWaiter",
    bookingMenusGetBookingMenu = "BookingMenus.GetPublicBookingMenu",
    getPublicMenuInfo = "Menus.GetPublicMenuInfo"
}
